import React from 'react';
import { Typography, Divider } from 'antd';

const { Title, Paragraph, Text } = Typography;

const Terms: React.FC = () => (
  <div style={{ background: '#fff', maxWidth: 800, margin: '0 auto', padding: '40px 24px' }}>
    <Title level={2}>Terms of Service</Title>
    <Paragraph>
      <Text strong>COMPANY:</Text> Shaho Solutions Limited<br />
      <Text strong>TRADING AS:</Text> ShahoSuite<br />
      <Text strong>CONTACT EMAIL:</Text> admin@shahosuite.com<br />
      <Text strong>EFFECTIVE DATE:</Text> 15 March 2026<br />
      <Text strong>GOVERNING LAW:</Text> England and Wales
    </Paragraph>
    <Divider />
    <Paragraph>
      <Text strong>1. Introduction and Acceptance</Text><br />
      These terms form a legal agreement between you and Shaho Solutions Limited.<br />
      By registering for or using ShahoSuite, you accept these terms.
    </Paragraph>
    <Paragraph>
      <Text strong>2. Subscription and Billing</Text><br />
      Business License: £50/month<br />
      Team Seat: £15/month per additional staff<br />
      Charged from day one — no free trial<br />
      Cancel anytime via the billing portal<br />
      Access continues until the end of the paid period<br />
      No refunds for partial months<br />
      Price Changes: ShahoSuite may update subscription prices from time to time. Any price change will be communicated with at least 30 days notice. Continued use after the effective date constitutes acceptance of the updated price.
    </Paragraph>
    <Paragraph>
      <Text strong>3. Account Responsibilities</Text><br />
      Keep your login credentials secure<br />
      One business per subscription<br />
      You are responsible for all data you enter
    </Paragraph>
    <Paragraph>
      <Text strong>4. Acceptable Use</Text><br />
      No illegal activity<br />
      No sharing accounts<br />
      No reverse engineering<br />
      No Professional Advice: Shaho Solutions Limited does not provide legal, financial, accounting, or tax advice. Any information generated by the platform is for general business use only.
    </Paragraph>
    <Paragraph>
      <Text strong>5. Service Availability</Text><br />
      We aim for 99.9% uptime<br />
      No guarantee of uptime or availability<br />
      Maintenance windows may occur<br />
      Third-Party Services: Shaho Solutions Limited is not responsible for outages, delays, or errors caused by third-party providers including Stripe, Microsoft Azure, and Azure Communication Services.<br />
      Service Interruptions: Access to the service may be interrupted for reasons outside our control.
    </Paragraph>
    <Paragraph>
      <Text strong>6. Data Accuracy</Text><br />
      Users are solely responsible for the accuracy of data they enter<br />
      Shaho Solutions Limited does not guarantee the accuracy, completeness, or reliability of any user-generated data<br />
      Shaho Solutions Limited is not responsible for losses resulting from incorrect data entered by users<br />
      Users are responsible for maintaining their own backups of exported data
    </Paragraph>
    <Paragraph>
      <Text strong>7. Limitation of Liability</Text><br />
      Service provided as is<br />
      No guarantee of security, accuracy, or compliance<br />
      To the maximum extent permitted by law, all implied warranties are excluded<br />
      Maximum liability is limited to 3 months of fees paid<br />
      No liability for indirect, incidental, or consequential losses<br />
      No personal liability is assumed by the founder, directors, or staff — all obligations apply to Shaho Solutions Limited only
    </Paragraph>
    <Paragraph>
      <Text strong>8. Service Changes</Text><br />
      We may modify or discontinue features at any time.<br />
      Material changes will be communicated with at least 30 days notice.
    </Paragraph>
    <Paragraph>
      <Text strong>9. Termination</Text><br />
      You may cancel anytime via the billing portal<br />
      Data is deleted after 30 days in accordance with GDPR<br />
      We may terminate accounts for breach of these terms
    </Paragraph>
    <Paragraph>
      <Text strong>10. Intellectual Property</Text><br />
      © 2026 Shaho Solutions Limited<br />
      All rights reserved<br />
      You may not copy, modify, or distribute any part of ShahoSuite
    </Paragraph>
    <Paragraph>
      <Text strong>11. Governing Law</Text><br />
      These terms are governed by the laws of England and Wales.<br />
      Disputes are subject to the exclusive jurisdiction of the English courts.
    </Paragraph>
    <Paragraph>
      <Text strong>12. Contact</Text><br />
      admin@shahosuite.com<br />
      Shaho Solutions Limited
    </Paragraph>
    <Divider />
    <div style={{ textAlign: 'center', marginTop: 40 }}>
      <Text type="secondary">© 2026 Shaho Solutions Limited. All rights reserved.</Text>
    </div>
  </div>
);

export default Terms;
